/**
 * useAuth
 * Thin wrapper around AuthContext to keep imports consistent across app layers.
 */
import { useAuthContext } from '../context/AuthContext';

export function useAuth() {
  return useAuthContext();
}
